<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>
   .el-form-item__label {
     color: initial;
     font-weight: normal;
   }
</style>


